import { render, staticRenderFns } from "./templatepreview.vue?vue&type=template&id=55650fb7"
import script from "./templatepreview.vue?vue&type=script&lang=js"
export * from "./templatepreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports